import { render, staticRenderFns } from "./SavedCar.vue?vue&type=template&id=58820d63&scoped=true"
import script from "./SavedCar.vue?vue&type=script&lang=js"
export * from "./SavedCar.vue?vue&type=script&lang=js"
import style0 from "./SavedCar.vue?vue&type=style&index=0&id=58820d63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58820d63",
  null
  
)

export default component.exports